import React, { useState, useEffect, useRef } from "react";
import classes from "./CashReciept.module.css";
import { useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import { BASE_URL } from "../../../Components/API/Api";
import api from "../../../Components/API/Api";
import Swal from "sweetalert2";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";

function CreateEmployee({ isOpen, onClose, employee }) {
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);
  const [taxIds, setTaxIds] = useState([]);
  const [taxMode, setTaxMode] = useState("input");
  // input | select | none

  const [selectedTaxId, setSelectedTaxId] = useState("");
  const [taxLoading, setTaxLoading] = useState(false);
  const [reference, setReference] = useState("");
  const [apiError, setApiError] = useState("");
  const navigate = useNavigate();
  const [debitSearch, setDebitSearch] = useState("");
  const [showDebitDropdown, setShowDebitDropdown] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [description, setDescription] = useState("");
  const [supervisor, setSupervisor] = useState("");
  const [accNo, setAccNo] = useState("");
  const [employmentStatus, setEmploymentStatus] = useState("");
  const [dateOfAppointment, setDateOfAppointment] = useState("");
  const [debitAccount, setDebitAccount] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [loanOptions, setLoanOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [paymentToLoading, setPaymentToLoading] = useState(false);
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  const [creditAccounts, setCreditAccounts] = useState([]);
  const [ninError, setNinError] = useState("");
  // Banks from paystack for Bank select
  const [bankOptions, setBankOptions] = useState([]);
  const [banksLoading, setBanksLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState("");

  const [totalAmount, setTotalAmount] = useState("");
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);
  const [paymentSearch, setPaymentSearch] = useState("");
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false);
  const [expenseOptions, setExpenseOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [receiptType, setReceiptType] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);
  const [employmentTypes, setEmploymentTypes] = useState([]);
  const [employmentStatuses, setEmploymentStatuses] = useState([]);
  const [employmentLoading, setEmploymentLoading] = useState(false);
  const [taxStations, setTaxStations] = useState([]);
  // new: tax agencies for Tax Agent (PAYE) select
  const [taxAgencies, setTaxAgencies] = useState([]);
  const [taxAgenciesLoading, setTaxAgenciesLoading] = useState(false);
  // new: grades and steps
  const [gradeOptions, setGradeOptions] = useState([]);
  const [gradeLoading, setGradeLoading] = useState(false);
  const [stepOptions, setStepOptions] = useState([]);
  const [stepLoading, setStepLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    address: "",
    account_number: "",
    bank_name: "",
    account_name: "",
    wht: "",
    stin: "",
    cac: "",
  });
  const [generatedEmpId, setGeneratedEmpId] = useState("");
  const formRef = useRef(null);
  const [canSave, setCanSave] = useState(false);
  // State for grade, step, and fetched basic salary
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedStep, setSelectedStep] = useState("");
  const [fetchedBasicSalary, setFetchedBasicSalary] = useState("");
  const [fetchingSalary, setFetchingSalary] = useState(false);
  const basicSalaryAutoFilled = Boolean(
    selectedGrade && selectedStep && fetchedBasicSalary && !fetchingSalary
  );

  // NEW: fields & verification state for NIN verification
  const [firstName, setFirstName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [selectedTaxAgent, setSelectedTaxAgent] = useState("");
  const [address, setAddress] = useState("");
  const [department, setDepartment] = useState("");
  const [unit, setUnit] = useState("");
  const [employmentType, setEmploymentType] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [pensionNumber, setPensionNumber] = useState("");
  const [nokName, setNokName] = useState("");
  const [relationship, setRelationship] = useState("");
  const [kinPhone, setKinPhone] = useState("");
  const [kinAddress, setKinAddress] = useState("");
  const [lastName, setLastName] = useState("");
  const [errorTxt, setErrorTxt] = useState("");
  const [nin, setNin] = useState(""); // national identification number
  const [verifyingNin, setVerifyingNin] = useState(false);
  const [verifiedNinImage, setVerifiedNinImage] = useState(null); // url or data URI
  const [lastVerifiedNin, setLastVerifiedNin] = useState(null);
  const [allowManualTaxId, setAllowManualTaxId] = useState(false); // Allow manual tax ID entry for non-OGIRS agencies

  // validate required fields (reads DOM values to avoid converting inputs to controlled)
  const validateRequired = () => {
    const requiredIds = [
      "empFirstName", "empLastName", "empGender", "empAddress", "empNin", "empEmail", "empPhone",
      "empDob", "empMarital", "empDept", "empUnit", "empType", "empJobTitle",
      "empAppointment", "empSupervisor", "empStatus", "empBank", "empSalary",
      "empKinName", "empKinRel", "empKinPhone", "empKinAddr"
    ];

    const getVal = id => (document.getElementById(id)?.value || "").toString().trim();

    // must have generated id
    if (!String(generatedEmpId).trim()) { setCanSave(false); return false; }

    // Require that the NIN field is present (do not require verified image to enable Save)
    if (!getVal("empNin")) { setCanSave(false); return false; }

    // Check grade and step from state (they're controlled components)
    if (!selectedGrade || !selectedStep) { setCanSave(false); return false; }

    for (const id of requiredIds) {
      if (!getVal(id)) { setCanSave(false); return false; }
    }

    // Check if basic salary is fetched when grade and step are selected (the salary field should have the value)
    if (selectedGrade && selectedStep && !fetchedBasicSalary && !fetchingSalary) {
      setCanSave(false);
      return false;
    }

    setCanSave(true);
    return true;
  };

  // attach listeners to the form so validation runs on user edits/resets; re-run when key values change
  useEffect(() => {
    if (!isOpen) { setCanSave(false); return; }
    const formEl = formRef.current || document.getElementById("empForm");
    if (!formEl) return;

    const onValidate = () => validateRequired();
    formEl.addEventListener("input", onValidate);
    formEl.addEventListener("change", onValidate);
    formEl.addEventListener("reset", onValidate);

    // initial run (useful when generatedEmpId or verifiedNinImage already set)
    onValidate();

    return () => {
      formEl.removeEventListener("input", onValidate);
      formEl.removeEventListener("change", onValidate);
      formEl.removeEventListener("reset", onValidate);
    };
  }, [isOpen, generatedEmpId, verifiedNinImage, selectedGrade, selectedStep, fetchedBasicSalary, firstName, lastName, nin]);

  // keep handlePrinter as-is
  const handlePrinter = () => {
    const receiptData = {
      reference,
      transactionDate,
      description,
      selectedCurrency,
      selectedPaymentMode,
      debitAccount,
      totalAmount,
      rows,
    };

    navigate("/preview", {
      state: { invoice: receiptData },
    });
  };

  // --- Update outstandingAmount when reference (customer selection) changes ---
  useEffect(() => {
    if (!receiptType?.toLowerCase()?.includes("credit customer")) {
      setOutstandingAmount("");
      return;
    }

    if (!reference) {
      setOutstandingAmount("");
      return;
    }

    const customerObj = customerOptions.find(c => String(c.id) === String(reference));
    const balance = customerObj?.balance ?? 0;
    setOutstandingAmount(String(Number(balance) || 0));
  }, [reference, customerOptions, receiptType]);

  // --- Fetch customers (only when receiptType includes credit customer) ---
  useEffect(() => {
    const fetchCustomers = async () => {
      if (!receiptType?.toLowerCase()?.includes("credit customer")) return;

      try {
        setCustomerLoading(true);
        const res = await api.get(`/v1/customer/get`);

        if (res.data && Array.isArray(res.data.data)) {
          setCustomerOptions(res.data.data);
        } else {
          setCustomerOptions([]);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        setCustomerOptions([]);
      } finally {
        setCustomerLoading(false);
      }
    };

    fetchCustomers();
  }, [receiptType]);

  // --- Fetch loans (when receiptType includes loan repayment) ---
  useEffect(() => {
    const fetchLoanOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("loan repayment")) return;

      try {
        setPaymentToLoading(true);
        const res = await api.get(`/v1/loans`);

        if (res.data && Array.isArray(res.data.data)) {
          setLoanOptions(res.data.data);
        } else {
          setLoanOptions([]);
        }
      } catch (err) {
        console.error("Error fetching loans:", err);
        setLoanOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchLoanOptions();
  }, [receiptType]);

  // --- Fetch employees (when receiptType includes employee payment) ---
  useEffect(() => {
    const fetchEmployeeOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("employee payment")) return;

      try {
        setPaymentToLoading(true);
        const res = await api.get(`/v1/employees`);

        if (res.data && Array.isArray(res.data.data)) {
          setEmployeeOptions(res.data.data);
        } else {
          setEmployeeOptions([]);
        }
      } catch (err) {
        console.error("Error fetching employees:", err);
        setEmployeeOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchEmployeeOptions();
  }, [receiptType]);

  // --- Fetch payment types ---
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      setPaymentTypesLoading(true);
      try {
        const res = await api.get(`/v1/get_type_of_payments`, {
          params: { name: "payment" },
        });
        if (res.data && Array.isArray(res.data.data)) {
          setPaymentTypes(res.data.data);
        } else {
          setPaymentTypes([]);
        }
      } catch (err) {
        setPaymentTypes([]);
      } finally {
        setPaymentTypesLoading(false);
      }
    };
    fetchPaymentTypes();
  }, []);

  // --- Fetch suppliers when selectedPaymentType includes supplier ---
  useEffect(() => {
    const fetchSuppliers = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      if (!type.includes("supplier")) {
        setSupplierOptions([]);
        return;
      }

      setSupplierLoading(true);
      try {
        const res = await api.get(`/v1/beneficiary`);

        const suppliers = res?.data?.data;
        if (Array.isArray(suppliers)) {
          const options = suppliers.map((s) => ({
            id: s.id,
            name: s.supplier_name || s.name || `Supplier ${s.id}`,
          }));
          setSupplierOptions(options);
        } else {
          setSupplierOptions([]);
        }
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        setSupplierOptions([]);
      } finally {
        setSupplierLoading(false);
      }
    };

    fetchSuppliers();
  }, [selectedPaymentType]);

  // --- Fetch Account Names and Codes ---
  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const res = await api.get(`/v1/get-expense-accounts`);
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setAccounts(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchAccounts();
  }, []);

  // --- Fetch Payment Methods ---
  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const res = await api.get(`/v1/income/get-payment-method`);

        if (res.data && Array.isArray(res.data.data)) {
          setPaymentModes(res.data.data);
        } else {
          setPaymentModes([]);
        }
      } catch (err) {
        console.error("Error fetching payment methods:", err);
        setPaymentModes([]);
      }
    };
    fetchPaymentModes();
  }, []);

  // --- Fetch Currencies ---
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const res = await api.get(`/v1/fetch-all-currencies`);

        if (res.data && Array.isArray(res.data.data)) {
          setCurrencyOptions(res.data.data);

          // ✅ Set NGN as default
          const ngnCurrency = res.data.data.find(c => c.code === "NGN");
          if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
        }
      } catch (err) {
        console.error("Error fetching currencies:", err);
      }
    };
    fetchCurrencies();
  }, []);

  useEffect(() => {
    const fetchCreditAccounts = async () => {
      setDebitAccountsLoading(true);
      try {
        const res = await api.get("/v1/bank-accounts");

        if (res.data && Array.isArray(res.data.data)) {
          const creditAccounts = res.data.data.map((acc) => ({
            value: acc.id,
            label: acc.gl_name || acc.name || acc.account_name,
          }));
          setCreditAccounts(creditAccounts);
        } else {
          setCreditAccounts([]);
        }
      } catch (error) {
        console.error("Error fetching credit accounts:", error);
        setCreditAccounts([]);
      } finally {
        setDebitAccountsLoading(false);
      }
    };

    if (isOpen) fetchCreditAccounts();
  }, [isOpen]);


  // Fetch banks for Bank Name select when modal opens
  useEffect(() => {
    const fetchBanks = async () => {
      setBanksLoading(true);
      try {
        const res = await api.get(`/v1/paystack/banks`);

        const banks = Array.isArray(res?.data?.data) ? res.data.data : res?.data || [];
        setBankOptions(banks);
      } catch (err) {
        console.error("Failed to fetch paystack banks:", err);
        setBankOptions([]);
      } finally {
        setBanksLoading(false);
      }
    };

    if (isOpen) fetchBanks();
  }, [isOpen]);

  // Reset state when modal closes
  useEffect(() => {
    if (!isOpen) {
      setSelectedGrade("");
      setSelectedStep("");
      setFetchedBasicSalary("");
      setFetchingSalary(false);
    }
  }, [isOpen]);

  // Fetch Grades and Steps when modal opens
  useEffect(() => {
    if (!isOpen) return;
    const fetchLookups = async () => {
      try {
        setGradeLoading(true);
        setStepLoading(true);
        const [gradesRes, stepsRes] = await Promise.all([
          api.get(`/v1/get-grades`),
          api.get(`/v1/get-steps`),
        ]);
        const grades = Array.isArray(gradesRes?.data?.data) ? gradesRes.data.data : [];
        const steps = Array.isArray(stepsRes?.data?.data) ? stepsRes.data.data : [];
        setGradeOptions(grades);
        setStepOptions(steps);
      } catch (err) {
        console.error("Failed to fetch grades/steps:", err);
        setGradeOptions([]);
        setStepOptions([]);
      } finally {
        setGradeLoading(false);
        setStepLoading(false);
      }
    };
    fetchLookups();
  }, [isOpen]);

  // NEW: lock background scroll only while modal is open
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      // restore previous overflow when modal closes/unmounts
      document.body.style.overflow = prev || "";
    };
  }, [isOpen]);

  // Fetch states when modal opens and populate taxStations
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await api.get(`/v1/fetch-all-state`);

        // Expecting an array at res.data.data
        const states = Array.isArray(res?.data?.data) ? res.data.data : [];
        setTaxStations(states);
      } catch (error) {
        console.error("Failed to fetch states:", error);
        setTaxStations([]);
      }
    };

    if (isOpen) fetchStates();
  }, [isOpen]);

  // Fetch tax agencies when modal opens and populate taxAgencies
  useEffect(() => {
    const fetchTaxAgencies = async () => {
      try {
        setTaxAgenciesLoading(true);
        const res = await api.get(`/v1/taxagency`);

        const agencies = Array.isArray(res?.data?.data) ? res.data.data : [];
        setTaxAgencies(agencies);
      } catch (err) {
        console.error("Failed to fetch tax agencies:", err);
        setTaxAgencies([]);
      } finally {
        setTaxAgenciesLoading(false);
      }
    };

    if (isOpen) fetchTaxAgencies();
  }, [isOpen]);

  // Fetch employment types & statuses when modal opens
  useEffect(() => {
    if (!isOpen) return;
    const fetchEmploymentData = async () => {
      try {
        setEmploymentLoading(true);
        const [typesRes, statusRes] = await Promise.all([
          api.get(`/v1/employee/employement_type`),
          api.get(`/v1/employee/employement_status`),
        ]);

        setEmploymentTypes(Array.isArray(typesRes?.data?.data) ? typesRes.data.data : []);
        setEmploymentStatuses(Array.isArray(statusRes?.data?.data) ? statusRes.data.data : []);
      } catch (err) {
        console.error("Failed to fetch employment types/statuses:", err);
        setEmploymentTypes([]);
        setEmploymentStatuses([]);
      } finally {
        setEmploymentLoading(false);
      }
    };

    fetchEmploymentData();
  }, [isOpen]);

  // Fetch generated employee id when modal opens and set it (read-only)
  useEffect(() => {
    if (!isOpen) return;
    const fetchEmpId = async () => {
      try {
        const companyId = localStorage.getItem("company_id");
        const res = await api.get(`/v1/employee/generate_number?company_id=${companyId}`);
        // expect generated id in res.data.data or res.data.number - adjust if different
        const idFromApi = res?.data?.data || res?.data?.number || "";
        setGeneratedEmpId(String(idFromApi));
      } catch (err) {
        console.error("Failed to fetch generated employee id:", err);
        setGeneratedEmpId("");
      }
    };
    fetchEmpId();
  }, [isOpen]);

  // Prefill form fields if employee prop is provided
  useEffect(() => {
    if (!employee) return;
    // Fill personal info
    setFirstName(employee.name?.split(" ")[0] || employee.first_name || "");
    setLastName(employee.name?.split(" ").slice(1).join(" ") || employee.last_name || "");
    setNin(employee.nin || "");
    setGeneratedEmpId(employee.employee_id || "");
    setSelectedGrade(String(employee.grade_id ?? employee.grade ?? ""));
    setSelectedStep(String(employee.step_id ?? employee.step ?? ""));
    setFetchedBasicSalary(employee.salary_structure?.basic_salary ? String(employee.salary_structure.basic_salary) : "");
    // Prefill bank selection if provided (prefer bank_id)
    setSelectedBank(employee.bank_id || employee.bank_id || employee.bank_name || "");
    // Optionally fill other fields if needed
    // ...add more as needed...
  }, [employee, isOpen]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: String(value) }));
  };

  // Selected WHT state helpers
  const selectedWht = taxStations.find((s) => String(s.id_no) === String(formData.wht));
  const isOgunStateSelected = (selectedWht?.state || "").toLowerCase() === "ogun state";

  // NEW: save handler used by the embedded employee form (was referenced but missing)
  const handleSaveForm = async () => {
    setApiError('');
    // if (e && typeof e.preventDefault === "function") e.preventDefault();

    // const valid = validateRequired();
    // if (!valid) {
    // setApiError("Please complete all mandatory fields before saving.")
    // Swal.fire({
    //   icon: "error",
    //   title: "Missing required fields",
    //   text: "Please complete all mandatory fields before saving.",
    //   zIndex: 1,
    // });
    // return;
    // }

    if (!firstName || !lastName || !generatedEmpId) {
      setApiError("First name, last name and generated Employee ID are required.");
      // Swal.fire({
      //   icon: "error",
      //   title: "Missing data",
      //   text: "First name, last name and generated Employee ID are required.",
      //   zIndex: 1,
      // });
      return;
    }

    // 🔥 START LOADER BEFORE API
    setIsSaving(true);

    const formData = new FormData();

    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("sex", gender);
    formData.append("employee_id", generatedEmpId);
    formData.append("home_address", address);
    formData.append("nin", nin);
    formData.append("email", email);
    formData.append("phone_no", phone);
    formData.append("dob", dob);
    formData.append("marital_status", maritalStatus);
    formData.append("department", department);
    formData.append("unit", unit);
    formData.append("employment_type", employmentType);
    formData.append("job_title", jobTitle);
    // Send both legacy and explicit *_id keys for backend compatibility
    if (selectedGrade) {
      formData.append("grade", selectedGrade);
      formData.append("grade_id", selectedGrade);
    }
    if (selectedStep) {
      formData.append("step", selectedStep);
      formData.append("step_id", selectedStep);
    }
    formData.append("date_of_first_appointment", dateOfAppointment);
    formData.append("manager_name", supervisor);
    formData.append("employment_status", employmentStatus);
    formData.append("bank_id", selectedBank);
    formData.append("account_number", accNo);
    formData.append("basic_salary", fetchedBasicSalary);
    formData.append("pension_number", pensionNumber);
    formData.append("stin", selectedTaxId);
    formData.append("tax_agent", selectedTaxAgent);
    formData.append("next_of_kin_name", nokName);
    formData.append("relationship", relationship);
    formData.append("next_of_kin_phone", kinPhone);
    formData.append("next_of_kin_address", kinAddress);

    if (verifiedNinImage) {
      formData.append("photo", verifiedNinImage);
    }

    try {
      const res = await api.post(`/v1/employee/add`, formData);

      if (res?.data?.status) {

        if (typeof onClose === "function") {
          onClose();
          setTimeout(() => {
            if (typeof isOpen === "function") isOpen();
          }, 200);
        }

        Swal.fire({
          icon: "success",
          title: "Saved",
          text: res.data.message || "Employee added successfully.",
        });

      } else {

        const msg = res?.data?.message;

        if (typeof msg === "object") {
          const combined = Object.values(msg).flat().join("; ");
          Swal.fire({
            icon: "error",
            title: "Save failed",
            text: combined
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Save failed",
            text: msg || "Failed to add employee."
          });
        }

      }
      setFirstName('');
      setLastName('');
      setDob('');
      setGender('');
      setMaritalStatus('');
      setNin('');
      setAddress('');
      setDepartment('');
      setUnit('');
      setEmploymentType('');
      setJobTitle('');
      setSelectedGrade('');
      setSelectedStep('');
      setDateOfAppointment('');
      setSupervisor('');
      setEmploymentStatus('');
      setSelectedBank('');
      setAccNo('');
      setFetchedBasicSalary('');
      setPensionNumber('');
      setSelectedTaxAgent('');
      setSelectedTaxId('');
      setAllowManualTaxId(false);
      setTaxMode("input");
      setNokName('');
      setRelationship('');
      setKinPhone('');
      setKinAddress('');

    } catch (error) {
      const msg = error?.response?.data?.message;
      setApiError(JSON.stringify(msg));
      // if (typeof msg === "string") setApiError(msg);
      // else if (typeof msg === "object")
      //   setApiError(Object.values(msg).flat().join("\n"));
      // else setApiError("Server error");
    } finally {

      // 🔥 STOP LOADER
      setIsSaving(false);

    }
  }

  // NEW: verify NIN endpoint call (uses component state) — switched to GET
  const verifyNin = async () => {
    const ninVal = (nin || "").trim();
    const fName = (firstName || "").trim();
    const lName = (lastName || "").trim();

    if (!ninVal || !fName || !lName) return;
    if (lastVerifiedNin && lastVerifiedNin === ninVal) return; // avoid duplicate

    setVerifyingNin(true);
    setNinError("");
    try {
      // use GET with query params
      const res = await api.get(`/v1/verify-nin`, {
        params: { nin: ninVal, first_name: fName, last_name: lName }
      });

      const data = res?.data?.data || {};
      // prefer "picture" (URL) first for display, fallback to nested nin_info.photo (base64) if absent
      let chosenImage =
        data.photo ||
        data.picture ||
        (data?.nin_info && data.nin_info.photo) ||
        null;

      // If API returned a raw data string (rare), accept that as data-uri if it already starts so
      if (!chosenImage && typeof res?.data === "string" && res.data.startsWith("data:image")) {
        chosenImage = res.data;
      }

      if (chosenImage) {
        if (typeof chosenImage === "string") {
          // 1) Remove literal backslashes that may remain from escaping (e.g. "\/")
          chosenImage = chosenImage.replace(/\\+/g, "");
          // 2) Replace any remaining escaped slash sequences
          chosenImage = chosenImage.replace(/\\\//g, "/");
          // 3) Trim whitespace
          chosenImage = chosenImage.trim();
        }

        // Detect URL vs base64-like payload
        const looksLikeUrl = typeof chosenImage === "string" && /^(https?:\/\/|\/\/)/i.test(chosenImage);
        // Allow leading slashes ("/9j/...") in base64 payloads, strip them for testing
        const candidateForBase64Test = typeof chosenImage === "string" ? chosenImage.replace(/^\/+/, "") : "";
        const looksBase64Like = /^[A-Za-z0-9+/=\s]+$/.test(candidateForBase64Test) && candidateForBase64Test.length > 100;

        // If it appears to be base64 (raw image data), convert to data URI
        if (looksBase64Like && !looksLikeUrl) {
          const cleanedBase64 = candidateForBase64Test.replace(/\s+/g, "");
          chosenImage = `data:image/jpeg;base64,${cleanedBase64}`;
        } else {
          // Normalize URL: collapse accidental multiple slashes but preserve protocol ("https://")
          if (typeof chosenImage === "string") {
            // collapse duplicate slashes except after protocol (http(s):)
            chosenImage = chosenImage.replace(/(^|[^:])\/{2,}/g, "$1/");
            // If it's still a relative path (starts with '/'), prepend BASE_URL
            if (/^\//.test(chosenImage) && !/^\/\//.test(chosenImage)) {
              chosenImage = `${BASE_URL.replace(/\/$/, "")}${chosenImage}`;
            }
          }
        }

        // set image only — no Swal here (user requested alerts only on save)
        setVerifiedNinImage(chosenImage);
      } else {
        // no image, just rely on inline status — do not show Swal
        console.info("NIN verified but no image returned.", res?.data?.message);
      }

      setLastVerifiedNin(ninVal);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "NIN verification failed. Please check the details.";

      setNinError(msg);
      setVerifiedNinImage(null);
    } finally {
      setVerifyingNin(false);
    }
  };

  // AUTO: trigger verification when nin reaches 11 digits and names are present
  useEffect(() => {
    const cleaned = (nin || "").replace(/\D/g, ""); // digits only
    const requiredLength = 11;
    if (!firstName || !lastName) return;
    if (cleaned.length !== requiredLength) return;
    if (lastVerifiedNin === cleaned) return;
    // set NIN state to digits-only (optional)
    if (cleaned !== nin) setNin(cleaned);
    // small debounce
    const t = setTimeout(() => verifyNin(), 300);
    return () => clearTimeout(t);
  }, [nin, firstName, lastName, lastVerifiedNin]);

  // Fetch basic salary when grade and step are selected
  useEffect(() => {
    const fetchBasicSalary = async () => {
      if (!selectedGrade || !selectedStep) {
        setFetchedBasicSalary("");
        return;
      }

      setFetchingSalary(true);
      try {
        const companyId = localStorage.getItem("company_id");
        const res = await api.get(`/v1/payroll/salary_structure/get_basic_pay?company_id=${companyId}`, {
          params: {
            grade_id: selectedGrade,
            step_id: selectedStep,
            basic_salary: true
          }
        });
        setFetchedBasicSalary(res.data.data[0]?.basic_salary ? String(res.data.data[0].basic_salary) : "");
        // Extract basic salary from response by filtering for matching grade_id and step_id
        // let basicSalary = null;

        // if (Array.isArray(res?.data?.data) && res.data.data.length > 0) {
        //   // Find the salary structure that matches both grade_id and step_id
        //   const matchingStructure = res.data.data.find(
        //     (item) => 
        //       String(item.grade_id) === String(selectedGrade) && 
        //       String(item.step_id) === String(selectedStep)
        //   );

        //   if (matchingStructure && matchingStructure.basic_salary) {
        //     basicSalary = matchingStructure.basic_salary;
        //   }
        // } else if (res?.data?.data?.basic_salary) {
        //   // Fallback if response is not an array
        //   basicSalary = res.data.data.basic_salary;
        // } else if (res?.data?.basic_salary) {
        //   // Another fallback
        //   basicSalary = res.data.basic_salary;
        // }

        // if (basicSalary) {
        //   setFetchedBasicSalary(String(basicSalary));
        // } else {
        //   setFetchedBasicSalary("");
        // }
      } catch (err) {
        console.error("Failed to fetch basic salary:", err);
        setFetchedBasicSalary("");
      } finally {
        setFetchingSalary(false);
      }
    };

    fetchBasicSalary();
  }, [selectedGrade, selectedStep]);

  if (!isOpen) return null;



  const fetchTaxIds = async (taxAgentId) => {
    setErrorTxt("");
    try {
      // Validate required fields before making API request
      if (!firstName || !lastName) {
        setErrorTxt("Please enter First Name and Last Name before selecting Tax Agent");
        setTaxLoading(false);
        return;
      }

      const token = localStorage.getItem("authToken");
      const companyId = localStorage.getItem("company_id");

      setTaxLoading(true);

      Swal.fire({
        title: "Fetching Tax IDs",
        text: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const res = await api.get(`/v1/employee/fetch_or_create_tin`, {
        params: {
          company_id: companyId,
          first_name: firstName,
          last_name: lastName,
          email: email,
          phone_no: phone,
          nin: nin,
          tax_agent: taxAgentId
        }
      });

      Swal.close();

      const data = res.data?.data || res.data;

      if (!data || data.length === 0) {
        setTaxMode("none");
        return;
      }

      if (data && data.tin) {
        setTaxMode("input");
        setSelectedTaxId(data.tin);
        return;
      }

      if (data.length === 1) {
        setTaxMode("input");
        setSelectedTaxId(data[0]);
      } else {
        setTaxMode("select");
        setTaxIds(data);
      }

    } catch (error) {

      Swal.close();
      
      // Handle error message - could be a string or object
      let errorMessage = "Failed to fetch tax IDs";
      if (error?.response?.data?.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (typeof error.response.data.message === "object") {
          // If message is an object with validation errors, join them
          errorMessage = Object.entries(error.response.data.message)
            .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(", ") : errors}`)
            .join("; ");
        }
      }
      
      setErrorTxt(errorMessage);

    } finally {
      setTaxLoading(false);
    }
  };



  const createTin = async () => {

    const email = document.getElementById("empEmail")?.value;
    const phone = document.getElementById("empPhone")?.value;
    const ninVal = document.getElementById("empNin")?.value;
    const taxAgent = document.getElementById("empTaxAgent")?.value;

    try {
      // Validate required fields before making API request
      if (!firstName || !lastName) {
        setErrorTxt("Please enter First Name and Last Name before creating Tax ID");
        return;
      }

      const companyId = localStorage.getItem("company_id");

      Swal.fire({
        title: "Creating STIN",
        text: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const res = await api.post(`/v1/employee/fetch_or_create_tin`, {
        company_id: companyId,
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone_no: phone,
        nin: ninVal,
        tax_agent: taxAgent
      });

      Swal.close();

      const data = res.data?.data || res.data;

      if (!data || data.length === 0) {
        setErrorTxt("TIN creation failed");
        return;
      }

      setTaxMode("input");
      setSelectedTaxId(data[0]);
      setErrorTxt("");

    } catch (error) {
      Swal.close();
      
      // Handle error message - could be a string or object
      let errorMessage = "Failed to create STIN";
      if (error?.response?.data?.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (typeof error.response.data.message === "object") {
          // If message is an object with validation errors, join them
          errorMessage = Object.entries(error.response.data.message)
            .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(", ") : errors}`)
            .join("; ");
        }
      }

      setErrorTxt(errorMessage);

    }

  };

  return (
    <div
      className={classes.modalOverlay}
      style={{ position: "fixed", inset: 0, overflow: "auto", zIndex: 9999, background: "rgba(0,0,0,0.4)" }}
    >
      <div

      >
        {/* Replaced modal content with provided Employee Record form (no background) */}
        <div className={classes.modalContent}
          style={{
            maxHeight: "90vh",
            overflowY: "auto",
            margin: "24px auto"
            , maxWidth: 900, margin: "0 auto", padding: 24, borderRadius: 12
          }}>
          <h1 style={{ textAlign: "center", marginTop: 0, }}>Employee Record Form</h1>
          <form id="empForm" ref={formRef} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginTop: 20 }}>
            <h2 style={{ gridColumn: "1 / -1", marginTop: 0, color: "#0f172a", borderBottom: "2px solid #e2e8f0", paddingBottom: 4, fontSize: 18 }}>Personal Information</h2>
            <div>
              <label>Employee ID</label>
              <input id="empId" type="text" placeholder="Generating..." value={generatedEmpId} readOnly required />
            </div>
            <div>
              <label>First Name</label>
              <input id="empFirstName" type="text" placeholder="Employee first name" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
            </div>
            <div>
              <label>Last Name</label>
              <input id="empLastName" type="text" placeholder="Employee last name" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
            </div>
            <div>
              <label>Date of Birth</label>
              <input id="empDob" type="date" value={dob} onChange={(e) => setDob(e.target.value)} />
            </div>
            <div>
              <label>Gender</label>
              <select id="empGender"
                value={gender}
                onChange={(e) => setGender(e.target.value)}>
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div>
              <label>Marital Status</label>
              <select
                id="empMarital"
                value={maritalStatus}
                onChange={(e) => setMaritalStatus(e.target.value)}
              >
                <option value="">Select Marital Status</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
                <option value="divorced">Divorced</option>
                <option value="widowed">Widowed</option>
              </select>
            </div>
            <div>
              <label>Phone Number</label>
              <input id="empPhone" type="tel" placeholder="e.g. 08012345678" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </div>
            <div>
              <label>Email Address</label>
              <input id="empEmail" type="email" placeholder="e.g. employee@company.com" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label>National ID / NIN</label>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexDirection: "column", alignItems: "stretch" }}>
                <input
                  id="empNin"
                  type="text"
                  placeholder="e.g. 22144567890"
                  value={nin}
                  onChange={(e) => {
                    setNin(e.target.value);
                    setNinError("");
                  }}
                />
                {/* small status message under input */}
                <div
                  style={{
                    minHeight: 18,
                    marginTop: 1,
                    fontSize: 13,
                    color: verifyingNin
                      ? "#2563eb"
                      : ninError
                        ? "#dc2626"
                        : verifiedNinImage
                          ? "#16a34a"
                          : "#6b7280",
                  }}
                >
                  {verifyingNin
                    ? "Processing verification..."
                    : ninError
                      ? ninError
                      : verifiedNinImage
                        ? "NIN verified"
                        : ""}
                </div>
              </div>
            </div>
            <div>
              {/* Employee Image / Verified NIN preview */}
              <div className={classes.osm_logoDrop}>
                <div className={classes.osm_avatar}>
                  {verifiedNinImage ? (
                    <img
                      src={verifiedNinImage}
                      alt="Verified NIN"
                      style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8 }}
                    />
                  ) : null}
                </div>

                <div className={classes.osm_uploadControls}>
                  {/* <div className={classes.osm_smallMuted}>PNG, JPG up to 2MB. Recommended 400×400</div> */}
                  {/* <div className={classes.osm_uploadButtons}>
                                <label className={`${classes.osm_btn} ${classes.osm_btnGhost}`} htmlFor="logoInput">Choose file</label>
                                <button type="button" onClick={handleRemoveLogo} className={`${classes.osm_btn}`}>Remove</button>
                              </div> */}
                  {/* <input id="logoInput" type="file" accept="image/*" className={classes.osm_hiddenInput}  */}
                  {/* // onChange={handleLogoChange} disabled={loading}  */}
                  {/* /> */}
                </div>
              </div>
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label>Residential Address</label>
              <textarea id="empAddress" placeholder="Enter home address" style={{ minHeight: 60 }} value={address} onChange={(e) => setAddress(e.target.value)} />
            </div>

            <h2 style={{ gridColumn: "1 / -1", marginTop: 30 }}>Employment Information</h2>
            <div><label>Department</label><input id="empDept" type="text" placeholder="e.g. Finance" value={department} onChange={(e) => setDepartment(e.target.value)} /></div>
            <div><label>Unit</label><input id="empUnit" type="text" placeholder="e.g. Payroll" value={unit} onChange={(e) => setUnit(e.target.value)} /></div>
            <div>
              <label>Employment Type</label>
              <select id="empType" defaultValue="" value={employmentType} onChange={(e) => setEmploymentType(e.target.value)}>
                <option value="">Select employment type</option>
                {employmentTypes.map((t) => (
                  <option key={t.id} value={t.id}>{t.name}</option>
                ))}
              </select>
            </div>
            <div><label>Job Title</label><input id="empJobTitle" type="text" placeholder="e.g. Accountant" value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} /></div>
            <div>
              <label>Grade</label>
              <select
                id="empGrade"
                value={selectedGrade}
                onChange={(e) => setSelectedGrade(e.target.value)}
              >
                <option value="" disabled>{gradeLoading ? "Loading grades..." : "Select Grade"}</option>
                {gradeOptions.map((g) => (
                  <option key={g.id ?? g.grade_id} value={g.id ?? g.grade_id}>
                    {g.description || g.name || `Grade ${g.id ?? g.grade_id}`}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label>Step</label>
              <select
                id="empStep"
                value={selectedStep}
                onChange={(e) => setSelectedStep(e.target.value)}
              >
                <option value="" disabled>{stepLoading ? "Loading steps..." : "Select Step"}</option>
                {stepOptions.map((s) => (
                  <option key={s.id ?? s.step_id} value={s.id ?? s.step_id}>
                    {s.description || s.name || `Step ${s.id ?? s.step_id}`}
                  </option>
                ))}
              </select>
            </div>
            <div><label>Date of Appointment</label><input id="empAppointment" type="date" value={dateOfAppointment} onChange={(e) => setDateOfAppointment(e.target.value)} /></div>
            <div><label>Supervisor / Manager</label><input id="empSupervisor" type="text" placeholder="Supervisor name" value={supervisor} onChange={(e) => setSupervisor(e.target.value)} /></div>
            <div>
              <label>Status</label>
              <select id="empStatus" defaultValue="" value={employmentStatus} onChange={(e) => setEmploymentStatus(e.target.value)}>
                <option value="">Select status</option>
                {employmentStatuses.map((s) => (
                  // use id as the value — API expects an id (not the name)
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>

            <h2 style={{ gridColumn: "1 / -1", marginTop: 30 }}>Payroll Information</h2>
            <div>
              <label>Bank Name</label>
              <select
                id="empBank"
                value={selectedBank}
                onChange={(e) => setSelectedBank(e.target.value)}
                style={{ width: "100%" }}
              >
                <option value="">Select Bank</option>
                {banksLoading ? (
                  <option value="" disabled>Loading...</option>
                ) : (
                  bankOptions.map((b, idx) => {
                    const label = b.name || b.bank_name || b.bank || b.bankname || b.full_name || `Bank ${idx}`;
                    const value = b.id || b.code || b.bank_code || label;
                    return (
                      <option key={value + idx} value={value}>
                        {label}
                      </option>
                    );
                  })
                )}
              </select>
            </div>
            <div>
              <label>Account Number</label>
              <input type="text" placeholder="e.g. 0123456789" value={accNo} onChange={(e) => setAccNo(e.target.value)} />
            </div>
            <div>
              <label>Monthly Rent Relief (₦)</label>
              <input
                id="empSalary"
                type="text"
                min="0"
                placeholder={
                  fetchingSalary
                    ? "Fetching..."
                    : basicSalaryAutoFilled
                      ? "Auto-populated from Grade/Step"
                      : "Enter basic salary"
                }
                value={fetchedBasicSalary}
                onChange={(e) => setFetchedBasicSalary(e.target.value)}
                readOnly={basicSalaryAutoFilled}
                disabled={basicSalaryAutoFilled}
                style={{
                  backgroundColor: basicSalaryAutoFilled ? "#f3f4f6" : "#ffffff",
                  color: basicSalaryAutoFilled ? "#6b7280" : "#111827",
                  cursor: basicSalaryAutoFilled ? "not-allowed" : "text",
                  opacity: basicSalaryAutoFilled ? 0.85 : 1,
                }}
              />
            </div>
            <div>
              <label>Pension Number</label>
              <input id="empPension" type="text" placeholder="e.g. PEN123456" value={pensionNumber} onChange={(e) => setPensionNumber(e.target.value)} />
            </div>
            <div>
              <label>Tax Agent (PAYE)</label>
              {/* Tax Agent options populated from /v1/taxagency - option value is "abbreviation, agency_name, state" */}
              <select
                id="empTaxAgent"
                value={selectedTaxAgent}
                onChange={(e) => {
                  const id = e.target.value;
                  setSelectedTaxAgent(id);
                  
                  // Check if selected tax agency is OGIRS
                  const selectedAgency = taxAgencies.find(t => String(t.id) === String(id));
                  const isOgirs = selectedAgency?.abbreviation?.toUpperCase() === "OGIRS";
                  
                  if (isOgirs) {
                    // For OGIRS, fetch tax IDs from API
                    setAllowManualTaxId(false);
                    setTaxMode("input");
                    setSelectedTaxId("");
                    fetchTaxIds(id);
                  } else if (id) {
                    // For non-OGIRS agencies, allow manual entry
                    setAllowManualTaxId(true);
                    setTaxMode("manual");
                    setSelectedTaxId("");
                  } else {
                    // Reset if no selection
                    setAllowManualTaxId(false);
                    setTaxMode("input");
                    setSelectedTaxId("");
                  }
                }}
              >
                <option value="">Select</option>

                {taxAgenciesLoading ? (
                  <option value="" disabled>Loading...</option>
                ) : (
                  taxAgencies.map((t) => {
                    const label = `${t.abbreviation} - ${t.agency_name} - ${t.state}`;

                    return (
                      <option key={t.id} value={t.id}>
                        {label}
                      </option>
                    );
                  })
                )}
              </select>
            </div>
            <div>
              <label>Tax ID</label>

              {taxLoading && (
                <input
                  type="text"
                  disabled
                  value="Fetching tax IDs, please wait..."
                />
              )}

              {!taxLoading && taxMode === "input" && (
                <input
                  id="empTaxId"
                  type="text"
                  value={selectedTaxId}
                  readOnly
                />
              )}

              {!taxLoading && taxMode === "manual" && (
                <input
                  id="empTaxId"
                  type="text"
                  placeholder="Enter Tax ID manually"
                  value={selectedTaxId}
                  onChange={(e) => setSelectedTaxId(e.target.value)}
                />
              )}

              {!taxLoading && taxMode === "select" && (
                <select
                  id="empTaxId"
                  value={selectedTaxId}
                  onChange={(e) => setSelectedTaxId(e.target.value)}
                >
                  <option value="">Select Tax ID</option>

                  {taxIds?.tins?.map((tin, i) => (
                    <option key={i} value={tin}>
                      {tin}
                    </option>
                  ))}

                </select>
              )}

              {!taxLoading && taxMode === "none" && !allowManualTaxId && (
                <div style={{ fontSize: 13 }}>
                  No tax ID found.{" "}
                  <span
                    style={{ color: "#2563eb", cursor: "pointer" }}
                    onClick={createTin}
                  >
                    Create one
                  </span>
                </div>
              )}
              {errorTxt && (
                <div style={{ fontSize: 13, color: "red" }}>
                  {errorTxt}
                </div>
              )}
            </div>
            {/* <div>
              <label>State</label>
              
              <select
                type="text"
                name="wht"
                value={formData.wht}
                onChange={handleChange}
                className={classes.sel_pen}
              
              >
                <option value="">Select State</option>
                {taxStations.map((state) => (
                  <option key={state.id_no} value={state.id_no}>
                    {state.state}
                  </option>
                ))}
              </select>
            </div> */}


            <h2 style={{ gridColumn: "1 / -1", marginTop: 30 }}>Next of Kin Information</h2>
            <div><label>Next of Kin Name</label><input id="empKinName" type="text" placeholder="e.g. John Doe" value={nokName} onChange={(e) => setNokName(e.target.value)} /></div>
            <div><label>Relationship</label><input id="empKinRel" type="text" placeholder="e.g. Brother" value={relationship} onChange={(e) => setRelationship(e.target.value)} /></div>
            <div><label>Next of Kin Phone</label><input id="empKinPhone" type="tel" placeholder="e.g. 08012345678" value={kinPhone} onChange={(e) => setKinPhone(e.target.value)} /></div>
            <div style={{ gridColumn: "1 / -1" }}><label>Next of Kin Address</label><textarea id="empKinAddr" placeholder="Enter address" value={kinAddress} onChange={(e) => setKinAddress(e.target.value)} /></div>
            {apiError && (
              <div style={{ fontSize: 13, color: "red" }}>
                {apiError}
              </div>
            )}
            <div className={classes.actions} style={{ gridColumn: "1 / -1", textAlign: "right", marginTop: 10 }}>
              <button type="button" className={classes.secondaryBtn} onClick={() => {
                const f = document.getElementById('empForm');
                if (f) f.reset();
                setSelectedGrade("");
                setSelectedStep("");
                setFetchedBasicSalary("");
                setFetchingSalary(false);
              }}>Reset</button>
              <Button
                onClick={handleSaveForm}
                variant="success"
                className={classes.saveBtn}
                // type="submit"
                disabled={isSaving}
                style={{
                  opacity: (isSaving) ? 0.6 : 1,
                  cursor: (isSaving) ? "not-allowed" : "pointer",
                  transition: "opacity 120ms linear",

                }}
              >
                {isSaving ? (
                  <>
                    <Spinner animation="border" size="sm" role="status" aria-hidden="true" />{" "}
                    Saving...
                  </>
                ) : (
                  "Save Record"
                )}
              </Button>
            </div>
          </form>
          {/* keep existing modal close control */}
          <button className={classes.closeBtn} onClick={onClose}>×</button>
        </div>


      </div>
    </div>
  );
}

export default CreateEmployee;